import { UserRound, ClipboardList, Globe2, HeartHandshake } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";

const REASONS = [
  {
    icon: UserRound,
    title: "Personalized guidance",
    copy: "One consultant, one plan, built from your actual assessment — never a recycled template or a sales script.",
    large: true,
  },
  {
    icon: ClipboardList,
    title: "Transparent process",
    copy: "Clear timelines, honest fees, and written summaries after every call. You see everything we see.",
    large: false,
  },
  {
    icon: Globe2,
    title: "Cross-system experience",
    copy: "Admissions, visas, and careers across 15+ countries and education systems — we've navigated them all.",
    large: false,
  },
  {
    icon: HeartHandshake,
    title: "Human-first approach",
    copy: "We measure success by your outcome, not our invoice. If we're not the right fit, we'll tell you — and point you to who is.",
    large: true,
  },
];

export function WhyUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter={["04", "Why Us"]}
          title={
            <>
              Guidance that treats your future like{" "}
              <em className="font-editorial font-medium italic text-gold-dark">it matters.</em>
            </>
          }
        />

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-testid="why-us-grid">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.08}>
              <div
                data-testid={`why-us-card-${i}`}
                className="group relative h-full overflow-hidden rounded-3xl border border-border bg-bone p-8 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_22px_55px_rgba(10,41,30,0.1)]"
              >
                <span className="absolute right-0 top-0 h-24 w-24 translate-x-8 -translate-y-8 rounded-full bg-gold/10 transition-transform duration-500 group-hover:scale-[1.8]" />
                <r.icon className="relative h-8 w-8 text-forest transition-colors duration-300 group-hover:text-gold-dark" />
                <h3 className="relative mt-5 font-display text-xl font-bold text-forest-deep sm:text-2xl">
                  {r.title}
                </h3>
                <p className="relative mt-3 max-w-md text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {r.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
